// @ts-nocheck
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { ENERGY_CARD_BORDER, ENERGY_TEXT_SECONDARY } from './EnergyOverviewCard.jsx';

const BAR_COLOR = '#d5d9df';
const BAR_HOVER_COLOR = '#b8bec7';

const PowerOnHoursChart = ({ days, height = 220 }) => {
  const labels = _.map(days, day => moment(day.date).format('D MMM'));
  const data = {
    labels,
    datasets: [{
      data: _.map(days, day => Math.round((Number(day.powerOnHours) || 0) * 10) / 10),
      backgroundColor: BAR_COLOR,
      hoverBackgroundColor: BAR_HOVER_COLOR,
      borderWidth: 0,
    }],
  };
  const lastIndex = labels.length - 1;
  const options = {
    maintainAspectRatio: false,
    legend: { display: false },
    tooltips: {
      callbacks: {
        label: tooltipItem => `${tooltipItem.yLabel} h`,
      },
    },
    scales: {
      xAxes: [{
        gridLines: { display: false },
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          fontColor: ENERGY_TEXT_SECONDARY,
          fontSize: 10,
          // Only first and last day, as in the wireframe
          callback: (value, index) => (index === 0 || index === lastIndex ? value : null),
        },
      }],
      yAxes: [{
        gridLines: { borderDash: [3, 3], color: ENERGY_CARD_BORDER, drawBorder: false },
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 3,
          fontColor: ENERGY_TEXT_SECONDARY,
          fontSize: 10,
          callback: value => `${value} h`,
        },
      }],
    },
  };
  return (
    <div style={{ height, position: 'relative' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default PowerOnHoursChart;
